import { config } from '@/lib/config'

export interface CannyContext {
  page?: string
  url?: string
  projectId?: string | null
  userId?: string | null
  userEmail?: string | null
  userName?: string | null
  userAgent?: string
  language?: string
  viewport?: string
}

/**
 * Open Canny feedback widget with useful prefilled context.
 * Assumes CannyWidget has already loaded the SDK.
 */
export function openCannyFeedback(context: CannyContext = {}) {
  if (typeof window === 'undefined') return

  const url = context.url || window.location.href
  const page = context.page
  const projectId = context.projectId
  const userAgent = context.userAgent || window.navigator.userAgent
  const language = context.language || window.navigator.language
  const viewport =
    context.viewport || `${window.innerWidth || 0}x${window.innerHeight || 0}`

  const metaLines = [
    `URL: ${url}`,
    page ? `Page: ${page}` : null,
    projectId ? `Projet: ${projectId}` : null,
    `Navigateur: ${userAgent}`,
    `Langue: ${language}`,
    `Viewport: ${viewport}`,
    config.appVersion ? `Version: ${config.appVersion}` : null,
    `Environnement: ${config.env}`,
  ].filter(Boolean)

  const detailsTemplate =
    'Décrivez ce qui s\'est passé, étape par étape.\n\n' +
    '---\n' +
    'Contexte technique (rempli automatiquement) :\n' +
    metaLines.join('\n')

  // For now we only use the SDK for identify; opening is done via a normal link.
  // You can copy-paste the detailsTemplate into the Canny post description.

  const feedbackUrl = config.cannyFeedbackUrl

  if (!feedbackUrl) {
    console.warn('Canny: VITE_CANNY_FEEDBACK_URL not configured')
    console.info('Bug context (copy/paste into Canny):\n' + detailsTemplate)
    return
  }

  window.open(feedbackUrl, '_blank', 'noopener,noreferrer')
}
